import { atom } from "recoil";

export const landlordDataAtom = atom({
    key: "landlordDataAtom",
    default: {},
});

